<template>
    <vue-scroll>
        <div class="filler-articles-container">
            <p class="info-text">
                Filler articles are licensed for one-time use in this month's
                newsletter. You are not allowed to copy/use these articles in
                any form outside of your newsletter, or present any articles as
                written by you.
            </p>

            <el-form>
                <div
                    class="article-card precious-content"
                    v-for="(article, i) in form.filler_articles"
                    :key="article.id"
                >
                    <h3 class="card-title">Article {{ i + 1 }}</h3>
                    <el-row>
                        <el-col :span="6">
                            <div class="priority-section">
                                <div class="priority-label-row">
                                    <span>Priority:</span>
                                </div>
                                <div class="priority-radio-row">
                                    <el-radio-group
                                        :name="
                                            'radio-group-' +
                                            article.filler_article_id
                                        "
                                        v-model="article.priority"
                                    >
                                        <el-radio
                                            :label="
                                                FillerArticlePriorities.HIGH
                                            "
                                            >High</el-radio
                                        >
                                        <el-radio
                                            :label="FillerArticlePriorities.LOW"
                                            >Low</el-radio
                                        >
                                    </el-radio-group>
                                    <span
                                        v-if="!!article.priority"
                                        class="reset-priority"
                                        @click.prevent="article.priority = null"
                                        title="Reset priority"
                                    >
                                        <span class="reset-icon">&times;</span>
                                        <span class="reset-label">Reset</span>
                                    </span>
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="18">
                            <h4 class="article-headline">
                                {{ article.filler_article.headline }}
                            </h4>
                            <p v-html="article.filler_article.body"></p>
                        </el-col>
                    </el-row>
                </div>
            </el-form>
        </div>
    </vue-scroll>
</template>

<script>
import * as FillerArticlePriorities from "../../../../constants/filler-article-priorities";

export default {
    props: {
        form: {
            required: true,
            type: Object
        }
    },
    data() {
        return {
            FillerArticlePriorities
        };
    },
    created() {},
    mounted() {},
    methods: {}
};
</script>

<style scoped>
.filler-articles-container {
    max-width: 1800px;
    margin: 0;
    padding-left: 20px;
}

.info-text {
    margin-bottom: 20px;
    max-width: 1000px;
}

.article-card {
    background-color: #f9f9f9;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    padding: 20px;
    border: 1px solid #eaeaea;
    margin-bottom: 20px;
}

.card-title {
    margin-bottom: 20px;
    padding-left: 5px;
    color: #333;
    font-size: 18px;
    border-bottom: 1px solid #e0e0e0;
    padding-bottom: 10px;
}

.article-headline {
    font-weight: bold;
    margin-bottom: 10px;
    color: #333;
}

.priority-section {
    padding: 10px;
    border-radius: 4px;
}

.priority-label-row {
    margin-bottom: 2px;
    font-weight: 500;
}

.priority-radio-row {
    display: flex;
    align-items: center;
    gap: 10px;
}

.reset-priority {
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-left: 12px;
    font-size: 12px;
    color: #888;
    transition: color 0.2s;
    user-select: none;
}
.reset-priority:hover {
    color: #d9534f;
}
.reset-icon {
    font-size: 16px;
    margin-right: 2px;
    line-height: 1;
}
.reset-label {
    font-size: 12px;
    line-height: 1;
}

.precious-content {
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    -o-user-select: none;
    user-select: none;
}
</style>
